import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Icon } from 'ui/atoms';
import theme from 'ui/theme';

import { MultiDropdown } from '..';

import { IconWrapper, InputContainer, InputWrapper } from './style';

const SearchSection = ({
  dropdowns = [],
  onSubmitDropdown,
  searchPlaceholder,
  onSubmitSearch,
  searchValue
}) => {
  const [search, setSearch] = useState(searchValue);

  const onHandleKeyDown = e => {
    if (e.keyCode === 13) {
      onSubmitSearch(search);
    }
  };

  useEffect(() => {
    setSearch(searchValue);
  }, [searchValue]);

  return (
    <>
      {dropdowns.length > 0 && (
        <MultiDropdown
          dropdownList={dropdowns}
          onSubmit={onSubmitDropdown}
          height="72px"
        />
      )}
      {onSubmitSearch && (
        <InputContainer>
          <InputWrapper
            type="text"
            value={search || ''}
            placeholder={searchPlaceholder}
            onKeyDown={onHandleKeyDown}
            onChange={e => setSearch(e.target.value)}
          />
          <IconWrapper onClick={() => onSubmitSearch(search)}>
            <Icon type="icon-search" size="28" color={theme().colors.white} />
          </IconWrapper>
        </InputContainer>
      )}
    </>
  );
};

SearchSection.propTypes = {
  dropdowns: PropTypes.array,
  onSubmitDropdown: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onSubmitSearch: PropTypes.func,
  searchValue: PropTypes.string
};

export default SearchSection;
